import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbTypeahead, NgbTypeaheadModule, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Subject, OperatorFunction, Observable, debounceTime, distinctUntilChanged, filter, merge, map } from 'rxjs';
import { ProtuneApiService } from '../../services/protune-api.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TRACK_LIST, Track } from '../../models/tracks';

@Component({
  selector: 'app-track-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbTypeaheadModule],
  templateUrl: './track-selector.component.html',
  styleUrl: './track-selector.component.scss'
})
export class TrackSelectorComponent {

  @Input({ required: true }) model: Track;

  @Output() modelChange = new EventEmitter<Track>()

  @ViewChild('trackSearch', { static: true }) trackSearch: NgbTypeahead;

  tracks: Array<Track>;
  trackList = [{ id: -1, name: 'Fast', type: 'fast' }, { id: -2, name: 'Technical', type: 'technical' }, ...TRACK_LIST] as Track[];



  constructor(private protuneApiService: ProtuneApiService, private errorHandler: ErrorHandlerService) { }

  ngOnInit() {
   
  }

  selectTrack(track: Track) {
    this.modelChange.emit(track);
  }

  focusTrackSearch$ = new Subject<string>();
  clickTrackSearch$ = new Subject<string>();

  searchTracks: OperatorFunction<string, readonly Track[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(300), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.clickTrackSearch$.pipe(filter(() => this.trackSearch.isPopupOpen()));
    const inputFocus$ = this.focusTrackSearch$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$)
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map((term) => {
          if (term === '') {
            return this.trackList;
          }
          return term.length < 2 ? [] : this.trackList.filter((t) => t.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        },
        ),
      );
  }

  trackInputFormatter(track: Track) {
    return track.name;
  }

  clearTrack() {
    this.model = null;
    this.modelChange.emit(this.model);
  }

}
